const isLocalHost=true;
const Configuration = {

      /*
    isLocalHost: true,
    lenderJsonPath: (isLocalHost)?"/static/json/PL_Lender_Table_final_min.json":"/wp-content/plugins/lenders-list/json/PLMP_Lender_Config_V005.json",
    lenderJsonPathV2: (isLocalHost)?"/static/json/PL_Lender_Table_final_minV2.json":"/wp-content/plugins/lenders-list/json/PLMP_Lender_Config_V005.json",
      */
      isLocalHost: false,
      lenderJsonPath: "/wp-content/plugins/lenders-list/static/json/PL_Lender_Table_final_min.json",
      lenderJsonPathV2: "/wp-content/plugins/lenders-list/static/json/PL_Lender_Table_final_minV2.json"
    //DEMO_DEPLOY lenderJsonPath: "/pr_loans/wp-content/plugins/lenders-list/static/json/PL_Lender_Table_final_min.json"
    // transitionPageUrl: "https://54.164.113.123/redirect"
};
export { Configuration }


// WEBPACK FOOTER //
// ./src/Configuration.js